import GSAP from 'gsap'
export default class Menu {
  constructor() {
    //setup
    this.burgerIcon = document.querySelector('.menu_icon')
    this.menu = document.querySelector('.menu')
    this.menuList = document.querySelector('.menu_list_inner')
    this.menu.style.height = 0
    this.menuListItem = document.querySelectorAll('.menu_list_item')
    this.menuListTitle = document.querySelectorAll('.menu_content h2')
    this.menuListText = document.querySelectorAll('.menu_content p')
    this.menuListArrow = document.querySelectorAll('.menu_content_info .arrow')

    //Method
    this.menuEvent()
    this.menuHover()
    this.scrollListItem()
  }
  menuEvent() {
    //menu event
    let tl = new GSAP.timeline({ paused: true, reversed: true })
    tl.to(this.menu.style, 0.5, {
      height: '100%',
      ease: 'Power1.easeOut',
      duration: 1,
    })
      .from(this.menuListItem, { autoAlpha: 0, y: 20, duration: 0.5 })
      .from(this.menuListTitle, { autoAlpha: 0, y: 20, duration: 0.5 })
      .from(this.menuListText, { autoAlpha: 0, y: 5, duration: 0.5 })
      .from(this.menuListArrow, { autoAlpha: 0, y: 5, duration: 0.5 })

    this.burgerIcon.addEventListener('click', () => {
      tl.reversed() ? tl.play().timeScale(1) : tl.timeScale(1.5).reverse()
    })
  }
  menuHover() {
    this.menuListItem.forEach(element => {
      element.addEventListener('mouseover', e => {
        const target = e.currentTarget.firstChild
        const bounding = target.getBoundingClientRect()
        const moveX = ((e.pageX - bounding.left) / bounding.width) * 25
        const moveY = ((e.pageY - bounding.top) / bounding.height) * 25
        target.style.left = moveX + 'px'
        target.style.top = moveY + 'px'
      })
    })
  }
  scrollListItem() {
    let sliderGrab = false
    this.menuList.addEventListener('mousedown', e => {
      sliderGrab = true
      this.menuList.style.cursor = 'grabbing'
    })
    this.menuList.addEventListener('mouseup', e => {
      sliderGrab = false
      this.menuList.style.cursor = 'grab'
    })
    this.menuList.addEventListener('mouseleave', e => {
      sliderGrab = false
      this.menuList.style.cursor = 'grab'
    })
    //move
    this.menuList.addEventListener('mousemove', e => {
      if (sliderGrab) {
        this.menuList.parentElement.scrollLeft -= e.movementX
      }
    })
    //scroll
    this.menuList.addEventListener('wheel', e => {
      e.preventDefault()
      this.menuList.parentElement.scrollLeft += e.deltaY
    })
  }
}

new Menu()
